import type { EChartsOption } from 'echarts';
import { getInstanceByDom } from 'echarts';

import { htmlNodes } from './htmlNodes';

const PRINT_COPY_TEXT_COLOR = '#1a1a1a';

const EXPORT_GRID_BOTTOM_OFFSET = '100';
const EXPORT_LEGEND_BOTTOM_PX = 28;

const axisLabelOverride = { axisLabel: { color: PRINT_COPY_TEXT_COLOR } };

const buildExportOverrides = (): EChartsOption => {
  return {
    xAxis: axisLabelOverride,
    yAxis: axisLabelOverride,
    grid: { bottom: EXPORT_GRID_BOTTOM_OFFSET },
    legend: {
      show: true,
      bottom: EXPORT_LEGEND_BOTTOM_PX,
      textStyle: { color: PRINT_COPY_TEXT_COLOR },
    },
  };
};

function getChartInstance(container: HTMLDivElement) {
  const canvas = container.querySelector('canvas');
  return (
    getInstanceByDom(container) ??
    (container.firstElementChild instanceof HTMLDivElement
      ? getInstanceByDom(container.firstElementChild)
      : undefined) ??
    (canvas?.parentElement instanceof HTMLElement
      ? getInstanceByDom(canvas.parentElement)
      : undefined)
  );
}

export const generateImageTag = (chartRef: HTMLDivElement) => {
  const canvases = chartRef?.querySelectorAll('canvas');

  if (!canvases || canvases.length === 0) {
    return '';
  }

  const chartInstance = getChartInstance(chartRef);

  if (!chartInstance) {
    return Array.from(canvases)
      .map(canvas => htmlNodes.img(canvas.toDataURL('image/png', 1.0)))
      .join('');
  }

  const originalOption = chartInstance.getOption();
  const overrides = buildExportOverrides();

  try {
    chartInstance.setOption(overrides);
    chartInstance.resize();

    const dataUrl = chartInstance.getDataURL({
      type: 'png',
      pixelRatio: 1,
    });

    return htmlNodes.img(dataUrl);
  } finally {
    chartInstance.setOption(originalOption, { notMerge: true });
    chartInstance.resize();
  }
};
